
import { useState, useEffect } from 'react';

interface Currency {
  code: string;
  symbol: string;
  name: string;
}

export const useCurrency = () => {
  const [selectedCurrency] = useState<Currency>({
    code: 'KES',
    symbol: 'KSh',
    name: 'Kenyan Shilling'
  });

  const formatAmount = (amount: number): string => {
    return `KSh ${amount.toLocaleString()}`;
  };

  const parseAmount = (formattedAmount: string): number => {
    return parseFloat(formattedAmount.replace(/[^0-9.-]+/g, ''));
  };

  return {
    selectedCurrency,
    formatAmount,
    parseAmount
  };
};
